module.exports = __webpack_public_path__ + "static/media/cypress.28f75e26.svg";